<template lang="html">
  <div class="manageBatches" ref="manageBatches">
    <div class="content-i">
      <div class="content-box">
        <div v-if="((clientName !== 'unis' || clientName !== 'unistest') && (userLevel >= 2.00)) || ((clientName === 'unis' || clientName === 'unistest') && (userLevel >= 1.50))" class="element-wrapper">
          <h6 class="element-header">{{ t('titleManageBatches','titleManageBatches') }}</h6>
          <template v-if="showResponse">
            <div class="col-12">
              <b-alert variant="success" dismissible show fade @dismissed="hideResponse()">
                <span>{{ t('batchApprovedSuccess', 'batchApprovedSuccess') }}</span>
              </b-alert>
            </div>
          </template>
          <div class="element-box">
            <div>
              <div class="element-info">
                <div class="row">
                  <div class="col-12 col-sm-6 col-md-8">
                    <div class="element-info-with-icon">
                      <div class="element-info-icon">
                        <span class="os-icon os-icon-search2"></span>
                      </div>
                      <div class="element-info-text">
                        <h5 class="element-inner-header">{{ t('titleManageBatchesSearch','titleManageBatchesSearch') }}</h5>
                        <div class="element-inner-desc">{{ t('descManageBatchesSearch','descManageBatchesSearch') }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-3 col-md-4">
                    <i id="batchToggle" v-b-toggle.search class="os-icon os-icon-arrow-up float-right text-netsend-blue showhand"></i>
                  </div>
                </div>
              </div>
              <b-collapse id="search" ref="searchForm" v-model="visibleSearchBox">
                <form v-on:submit.prevent="requestBatches">
                  <div class="col-lg-12 row">
                    <div class="col-lg-2">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-ref" class="d-block text-center">{{t('searchLabelBatchRef','searchLabelBatchRef') }}</label>
                          <input id="batch-ref" v-model="batchEntriesRequest.batch_ref" class="form-control text-center" :placeholder="t('searchLabelBatchRef','searchLabelBatchRef')" type="text">
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-num" class="d-block text-center">{{ t('searchLabelBatchNum','searchLabelBatchNum') }}</label>
                          <input id="batch-num" v-model="batch_id" class="form-control text-center" :placeholder="'0'" type="text">
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-after" class="d-block text-center">{{t('searchLabelBatchDAfter','searchLabelBatchDAfter') }}</label>
                          <datePicker id="batch-after" v-model="batchEntriesRequest.upload_after" class="form-control text-center" :config="datePickerAfterConfig" :placeholder="t('searchLabelBatchDAfter','searchLabelBatchDAfter')"></datePicker>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-before" class="d-block text-center">{{ t('searchLabelBatchDBefore','searchLabelBatchDBefore') }}</label>
                          <datePicker id="batch-before" v-model="batchEntriesRequest.upload_before" class="form-control text-center" :config="datePickerBeforeConfig" :placeholder="t('searchLabelBatchDBefore','searchLabelBatchDBefore')">
                          </datePicker>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-type" class="d-block text-center">{{t('searchLabelBatchType','searchLabelBatchType') }}</label>
                          <select id="batch-type" v-model="batchEntriesRequest.batch_type" class="form-control custom-select text-capitalize">
                            <option :value="undefined" selected>{{t('selectAll','selectAll') }}</option>
                            <option v-for="batchType in batchTypes" :value="batchType.id" :key="batchType.id">{{ batchType.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-sub" class="d-block text-center">{{t('searchLabelSubBatchName','searchLabelSubBatchName') }}</label>
                          <input id="batch-sub" v-model="batchEntriesRequest.sub_batch_name" class="form-control text-center" :placeholder="t('searchLabelSubBatchName','searchLabelSubBatchName')" type="text">
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2" v-if="this.clientName == 'unis' || this.clientName == 'unistest'">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="invoice-from" class="d-block text-center">{{ t('searchLabelInvoiceFrom','searchLabelInvoiceFrom') }}</label>
                          <input id="invoice-from" v-model="batchEntriesRequest.invoice_from" class="form-control" :placeholder="'0'" type="text">
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="invoice-to" class="d-block text-center">{{ t('searchLabelInvoiceTo','searchLabelInvoiceTo') }}</label>
                          <input id="invoice-to" v-model="batchEntriesRequest.invoice_to" class="form-control" :placeholder="'0'" type="text">
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2" v-if="this.clientName == 'unis' || this.clientName == 'unistest'">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="invoice-num" class="d-block text-center">{{ t('searchLabelInvoiceNum','searchLabelInvoiceNum') }}</label>
                          <input id="invoice-num" v-model="batchEntriesRequest.invoice_number" class="form-control" :placeholder="'0'" type="text">
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="customer-num" class="d-block text-center">{{ t('searchLabelCustomerNum','searchLabelCustomerNum') }}</label>
                          <input id="customer-num" v-model="batchEntriesRequest.customer_number" class="form-control" :placeholder="'0'" type="text">
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2" v-if="Number(userLevel) >= 2">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <label for="batch-status" class="d-block text-center">{{ t('searchLabelBatchStatus','searchLabelBatchStatus') }}</label>
                          <b-form-select id="batch-status" v-model="batchEntriesRequest.batch_status" multiple :select-size="3" class="form-control custom-select text-capitalize">
                            <option :value="'all'" selected>{{t('optionAll','optionAll') }}</option>
                            <option :value="'approved'">{{t('optionApproved','optionApproved')}}</option>
                            <option :value="'proof'">{{t('optionUnapproved','optionUnapproved')}}</option>
                            <option :value="'rejected'">{{t('optionRejected','optionRejected')}}</option>
                          </b-form-select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 row justify-content-between">
                    <div class="col-lg-2">
                      <b-input-group class="form-group col-lg-12">
                        <b-input-group-prepend>
                          <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                        </b-input-group-prepend>
                        <b-form-select v-model="perPage" @change="fixInfinitePage" :options="pageOptions"></b-form-select>
                      </b-input-group>
                    </div>
                    <div class="form-group col-lg-2 align-self-center">
                      <button v-if="!isBusy" class="btn btn-primary float-right" @click="resetInfiniteScroll" type="submit">{{ t('searchButtonText','searchButtonText') }}</button>
                      <b-button v-if="isBusy" class="btn btn-primary float-right" variant="primary" disabled>
                        <b-spinner small type="grow"></b-spinner>
                        {{ t('searchButtonText','searchButtonText') }}
                      </b-button>
                    </div>
                  </div>
                </form>
              </b-collapse>
            </div>
          </div>
          <transition name="fade">
            <div class="scroll-top-div" v-if="showScrollTopButton">
              <button class="btn btn-primary" @click="scrollToTop()">
                <fontAwesomeIcon :icon="['fa', 'arrow-up']" style="color: white;"/>
              </button>
            </div>
          </transition>
          <!-- NS-10026 Show no batches found if no records were returned, PW -->
          <!-- EIPP-537 removed the overflow style. IS -->
          <div class="element-box" v-show="requestFinished">
            <div class="element-box-tp">
              <div v-if="!subOpened && batchEntries.data" class="controls-below-table row" :style="{ visibility:  paginationVisible ? 'visible' : 'hidden'}">
                <div class="col-12 mb-3">
                  <ToolBar @list-all-batches="listAllBatches" @expand-all-batches="expandAllBatches" @refresh-all-batches="requestBatches"/>
                </div>
                <div class="col-sm-12 col-md-6 table-records-info">
                  <p v-if="filter != null && filter.length" class="font-weight-bold mb-0">{{filteredRows}}</p>
                  <p v-else>
                    <template v-if="totalRows == 1">
                    {{totalRows}} {{ t('batchFoundLabel','batchFoundLabel') }}
                    </template>
                    <template v-else>
                    {{totalRows}} {{ t('batchesFoundLabel','batchesFoundLabel') }}
                    </template>
                  </p>
                </div>
                <div class="col-sm-12 col-md-4">
                  <b-pagination v-if="!infiniteScroll && batchEntries.data" ref="paginationTop" class="float-right mb-0" @change="manualPagination" :total-rows="totalRows" :per-page="perPage" aria-controls="batches-table">
                  </b-pagination>
                </div>
                <div class="col-sm-12 col-md-2">
                  <b-input-group class="form-group col-lg-12">
                    <b-input-group-prepend>
                      <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" @change="fixInfinitePage" :options="pageOptions"></b-form-select>
                  </b-input-group>
                </div>
              </div>
              <transition v-if="!arrivedToPage" mode="out-in" v-bind:name="animationName" v-on:enter="paginationVisibilityStart" v-on:after-enter="paginationVisibilityEnd" v-on:after-leave="paginationCorrector">
                <div key="1" id="table-main" v-if="(!subOpened) && batchEntries.data" class="table-responsive">
                  <b-table id="batches-table" striped hover bordered details-td-class="px-0 py-0" responsive class="mt-3" :busy.sync="isBusy" :items="batchEntries.data" :fields="fields" no-sort-reset :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                  :total-rows="totalRows" per-page="0" :currentPage="currentPage" :filter="filter" @filtered="onFiltered" :show-empty="rowEmpty" @row-hovered="hoverOn" @row-unhovered="hoverOff">
                    <template v-slot:head(id)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template #row-details="data">
                      <SubBatch v-if="data.item.sub_batch && data.item.sub_batch.length" :items="data.item.sub_batch" :parent="data.item.id" :busyTable="data.item.loading" :showBackButton="false"/>
                    </template>
                    <template v-slot:head(reference)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(documents)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(type)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(status)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(added_on)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-slot:head(show_details)="data">
                      <span >{{ t(data.label, data.label) }}</span>
                    </template>
                    <template v-if="!infiniteScroll" class="busy-row" v-slot:table-busy>
                      <!--<div class="vld-parent spinner-row text-center">
                        <loading :active.sync="isBusy"
                        :can-cancel="false"
                        :color="'#047bf8'"
                        :loader="'dots'"
                        :is-full-page="false"></loading>
                      </div>-->
                      <vcl-table v-if="isBusyTables" :rows="parseInt(perPage)" :columns="7"></vcl-table>
                    </template>
                    <template v-slot:empty="scope">
                      <div class="text-center"> {{ t('noEntriesFound','noEntriesFound') }} </div>
                    </template>
                    <template v-slot:cell(id)="data">
                      <span v-bind:class="{ 'text-danger': data.item.test_mode }">{{ data.item.id }}</span>
                      <span v-if="data.item.sub_batch && data.item.sub_batch.length">
                        <fontAwesomeIcon :icon="data.detailsShowing ? ['fa', 'minus'] : ['fa', 'plus']" class="text-primary ml-1" :class="{'showhand' : !data.item.loading, 'disablehand text-secondary' : data.item.loading}" @click="toggleDetails(data)"/>
                      </span>
                    </template>
                    <template v-slot:cell(reference)="row">
                      <div :title="row.item.reference + ' (' + row.item.filesize + ' bytes)'">
                        <span>
                          <a class="break-all" href="javascript:;" @click="downloadBatchData(row.item.id)">
                            {{ row.item.reference | trimBatchReference(batchRefTrim) }}
                          </a>
                        </span>
                        <span v-if="row.item.sub_batch && row.item.sub_batch.length" @click="showDetails(row)">
                          <fontAwesomeIcon :icon="['fa', 'folder-open']" class="text-primary showhand mr-2" size="1x"/>
                        </span>
                        <span v-if="quarantineStatus" class="d-none">
                          <fontAwesomeIcon v-if="row.item.total_failed > 0" :icon="['fas', 'exclamation']" class="text-danger" size="1x"/>
                        </span>
                        <div class="d-flex ">
                          <!-- EIPP-611 Removed status condition based on V1, PW -->
                          <b-button v-if="(Number(userLevel) == 3.00)" size="sm"
                            @click="routeToBatchStatus(row.item.id)"
                            class="mr-2">
                              {{ t('statusButtonText','statusButtonText') }}
                          </b-button>
                          <span v-if="(userLevel == '3.00')" class="ml-1">
                            <fontAwesomeIcon :icon="['fas', 'pen']" size="1x" :id="'edit-' + row.item.id"
                            @click="modalCreator({id: 'editModal', title: t('batchEditModalHead','batchEditModalHead'), open: 'open'}, row.item, $event.target)"
                            class="text-primary showhand align-middle" visibility="hidden"/>
                          </span>
                          <span v-if="batchInfoAccessLevel <= userLevel" class="ml-2">
                            <fontAwesomeIcon :icon="['fas', 'info-circle']" size="1x" :id="'info-' + row.item.id"
                            @click="modalCreator({id: 'infoModal', title: t('batchInfoModalHead','batchInfoModalHead'), open: 'open'}, row.item, $event.target)"
                            class="text-primary showhand align-middle" visibility="hidden"/>
                          </span>
                          <span v-if="(userLevel == '3.00') && (row.item.status == 'uploaded')" class="ml-2">
                            <fontAwesomeIcon :icon="['fa', 'ban']" size="1x" :id="'cancel-' + row.item.id"
                            @click="modalCreator({id: 'cancelModal', title: t('batchCancelModalHead','batchCancelModalHead'), open: 'open'}, row.item, $event.target)"
                            class="text-danger showhand align-middle" visibility="hidden"/>
                          </span>
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell(documents)="row">
                      <span v-if="row.item.loading">
                        <b-spinner small type="border"></b-spinner>
                      </span>
                      <span v-else>{{ row.item.total_docs }}</span>
                    </template>
                    <template v-slot:cell(type)="data">
                      <span>{{ data.item.batch_type.name}}</span>
                    </template>
                    <template v-slot:cell(status)="data">
                      <template v-if="data.item.loading">
                         <span>
                           <b-spinner small type="border"></b-spinner>
                         </span>
                      </template>
                      <template v-else>
                        <div v-if="!(data.item.sub_batch.length > 0)">
                        <span v-if="statusSettings[data.item.status]">
                         <b-badge v-if="statusSettings[data.item.status]" pill :class="statusSettings[data.item.status]['color']">{{t(statusSettings[data.item.status]['title'], statusSettings[data.item.status]['title'])}} </b-badge>
                        </span>
                          <span v-else> {{ data.item.status }} </span>
                        </div>
                        <div v-else>
                          <template v-if="data.item.status && typeof data.item.status === 'object'">
                            <div class="mb-2" v-for="(value, key) of data.item.status" :key="key">
                              <b-badge v-if="statusSettings[key]" pill :class="statusSettings[key]['color']">{{t(statusSettings[key]['title'], statusSettings[key]['title'])}} <b-badge pill variant="light">{{value}}</b-badge> </b-badge>
                            </div>
                          </template>
                        </div>
                      </template>
                    </template>
                    <template v-slot:cell(added_on)="data">
                      <span v-if="clientName == 'gskp' || clientName == 'gskptest'">{{ data.item.added_on | clientDateFormat2(datePickerFormat) }}</span>
                      <span v-else>{{ data.item.added_on | clientDateFormat(datePickerFormat) }}</span>
                    </template>
                    <template v-slot:cell(actions)="data">
                      <div class="d-flex align-items-center">
                        <div v-if="(data.item.sub_batch.length == 0) && (data.item.status == 'proof')" class="mr-2">
                          <div v-if="quarantineStatus">
                            <div v-if="((data.item.total_generated + data.item.total_failed) == data.item.total_documents)">
                              <span v-if="(clientName === 'unis' || clientName === 'unistest') && !(Number(userLevel) >= 1.60)">
                              </span>
                              <span v-else>
                                <button @click="routeToViewProof(data.item.id, data.item.tasksheet, clientName)" class="button btn btn-yellow text-white text-bold">
                                  {{ t('viewProofButtonText','viewProofButtonText') }}
                                </button>
                              </span>
                            </div>
                          </div>
                          <div v-else>
                            <span v-if="(clientName === 'unis' || clientName === 'unistest') && !(Number(userLevel) >= 1.60)">
                            </span>
                            <span v-else>
                              <button @click="routeToViewProof(data.item.id, data.item.tasksheet, clientName)" class="button btn btn-yellow text-white text-bold">
                                <span class="">{{ t('viewProofButtonText','viewProofButtonText') }}</span>
                              </button>
                            </span>
                          </div>
                        </div>
                        <div v-if="(data.item.sub_batch.length == 0) && (data.item.status == 'approved')" class="mr-2">
                          <span v-if="(clientName === ('unis' || 'unistest')) && !(Number(userLevel) >= 1.60)"></span>
                          <span v-else>
                            <button @click="routeToViewDocs(data.item.id, showTasksheets, clientName)" class="button btn btn-green text-white text-bold">
                              <span class="">{{ t('viewDocsButtonText','viewDocsButtonText') }}</span>
                            </button>
                          </span>
                        </div>
                        <template v-if="!(data.item.sub_batch.length > 0 && Number(userLevel) < 2.50)"> 
                          <template v-if="!(((data.item.status == 'approved') || (data.item.status == 'generating') || (data.item.status == 'uploaded')) && (Number(userLevel) < 3.00))">
                            <b-dropdown id="action-dropdown" :text="t('actionsButtonText', 'actionsButtonText')">
                              <!-- EIPP-291 Tweak to insert condition, PW -->
                              <b-dropdown-item v-if="(data.item.status == 'proof') && batchInsertEnabled" @click="routeToInsert(data.item.id)" class="text-center optn optn-blue">
                                <span class="text-white">{{ t('insertButtonText','insertButtonText') }}</span>
                              </b-dropdown-item>
                              <b-dropdown-item v-if="(data.item.sub_batch.length == 0) && (data.item.status == 'rejected')" @click="routeToRejected(data.item.id, showTasksheets)" class="text-center optn optn-grey">
                                <span class="text-white">{{ t('viewRejectedButtonText','viewRejectedButtonText') }}</span>
                              </b-dropdown-item>
                              <span v-if="(Number(userLevel) == 3.00) && (data.item.proof_reminders != 0)">
                                <b-dropdown-item  @click="modalCreator({id: 'cancelRemindersModal', title: t('cancelRemindersModalHead','cancelRemindersModalHead'), open: 'open'}, data.item, $event.target)" class="text-center optn optn-purple">
                                  <span class="text-white">{{ t('dontRemindButtonText','dontRemindButtonText') }}</span>
                                </b-dropdown-item>
                              </span>
                              <span v-if="(Number(userLevel) == 3.00)">
                                <b-dropdown-item @click="modalCreator({id: 'deleteModal', title: t('batchDeleteModalHead','batchDeleteModalHead'), open: 'open'}, data.item, $event.target)" class="text-center optn optn-red">
                                  <span class="text-white">{{ t('deleteButtonText','deleteButtonText') }}</span>
                                </b-dropdown-item>
                              </span>
                              <!-- EIPP-146 Made export available to SA and above, PW -->
                              <span v-if="(Number(userLevel) >= 2.50) && (clientName === 'vfne' || clientName === 'vfnetest') && (data.item.batch_type.name === 'SAP Statement' || data.item.batch_type.name === 'SAP Invoice')">
                                <b-dropdown-item @click="exportControlFile(data.item.id, data.item.reference)" class="text-center optn optn-purple">
                                  <span class="text-white">{{ t('exportControlFileText','exportControlFileText') }}</span>
                                </b-dropdown-item>
                              </span>
                            </b-dropdown>
                          </template>
                        </template>
                        <div v-if="data.item.sub_batch.length > 0" class="ml-2">
                          <button @click="showDetails(data)" class="btn btn-info text-white text-bold">{{ t('batchViewSubbatches', 'batchViewSubbatches') }}</button>
                        </div>
                      </div>
                    </template>
                  </b-table>
                  <infinite-loading v-if="!isBusy && infiniteScroll" force-use-infinite-wrapper="true" @infinite="infiniteHandler" slot="append">
                    <div slot="spinner"></div>
                    <div slot="no-more">{{ t('noMoreBatchesToDisplay', 'noMoreBatchesToDisplay') }}</div>
                  </infinite-loading>
                </div>
                <div key="2" id="table-sub" v-if="subOpened">
                  <SubBatch :items="subBatches" :parent="parentId" :busyTable="subLoading" :showBackButton="true"/>
                </div>
              </transition>
              <div v-if="!subOpened && this.batchEntries.data" class="controls-below-table pt-4" :style="{ visibility:  paginationVisible ? 'visible' : 'hidden'}">
                <div class="col-sm-12 col-md-6 table-records-info" v-if="this.batchEntries.data">
                  <p v-if="filter != null && filter.length" class="font-weight-bold mb-0">{{filteredRows}}</p>
                  <p v-else class="mb-0">
                      <template v-if="totalRows == 1">
                      {{totalRows}} {{ t('batchFoundLabel','batchFoundLabel') }}
                      </template>
                      <template v-else>
                      {{totalRows}} {{ t('batchesFoundLabel','batchesFoundLabel') }}
                      </template>
                  </p>
                </div>
                <div class="col-sm-12 col-md-4">
                  <b-pagination v-if="!infiniteScroll && batchEntries.data" ref="paginationBottom" class="float-right mb-0" @change="manualPagination" :total-rows="totalRows" :per-page="perPage" aria-controls="batches-table">
                  </b-pagination>
                </div>
                <div class="col-sm-12 col-md-2">
                  <b-input-group class="form-group col-lg-12">
                    <b-input-group-prepend>
                      <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" @change="fixInfinitePage" :options="pageOptions"></b-form-select>
                  </b-input-group>
                </div>
              </div>
            </div>
            <div v-if="totalRows && ( userLevel == '3.00') && (!subOpened)" class="form-buttons-w" :style="{ visibility:  paginationVisible ? 'visible' : 'hidden'}">
              <div class="d-flex justify-content-end">
                <button @click="modalCreator({id: 'deleteAllModal', title: t('testBatchesDeleteModalHead','testBatchesDeleteModalHead'), open: 'open'}, $event.target)" class="btn btn-secondary ">{{ t('deleteTestBatchesButtonText','deleteTestBatchesButtonText') }}</button>
              </div>
            </div>
            <ModalDontRemind :modal="this.modal"/>
            <ModalEditBatch :modal="this.modal"/>
            <ModalInfoBatch :modal="this.modal"/>
            <ModalCancelBatch :modal="this.modal"/>
            <ModalBatchDelete :modal="this.modal"/>
            <ModalDeleteAllTestBatches :modal="this.modal"/>
            <ModalDownloadData :dataUrl="dataUrl" />
            <div v-if="this.modal['modalData'].open || overlayActive" class="modal-backdrop show"></div>
          </div>
        </div>
        <div v-else>
          <h6 class="element-header">{{ t('titleManageBatches','titleManageBatches') }}</h6>
          <div class="element-box">
            <div class="element-box-tp text-center">
              <p>{{ t('noManageBatchesPermission', 'noManageBatchesPermission') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import datePicker from 'vue-bootstrap-datetimepicker'
import Loading from 'vue-loading-overlay'
import { clientShortName } from '@/helpers/clientShortName.js'
import { backendUrl } from '@/helpers/backendUrl.js'

import SubBatch from '@/components/Manage_Batches/SubBatch.vue'
import ModalEditBatch from '@/components/Manage_Batches/ModalEditBatch.vue'
import ModalInfoBatch from '@/components/Manage_Batches/ModalInfoBatch.vue'
import ModalCancelBatch from '@/components/Manage_Batches/ModalCancelBatch.vue'
import ModalBatchDelete from '@/components/Manage_Batches/ModalBatchDelete.vue'
import ModalDontRemind from '@/components/Manage_Batches/ModalDontRemind.vue'
import ModalDeleteAllTestBatches from '@/components/Manage_Batches/ModalDeleteAllTestBatches.vue'
import ModalDownloadData from '@/components/Helper_Components/ModalDownloadData.vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import { VclTable } from 'vue-content-loading'
import ToolBar from "@/components/Manage_Batches/ToolBar.vue";

export default {
    name: 'manage_batches',
    //these functions and values are inheritable from this component
    provide() {
      return {
        statusSettings: this.statusSettings,
        //computed values
        quarantineStatus: this.quarantineStatus,
        userLevel: this.userLevel,
        clientName: this.clientName,
        datePickerFormat: this.datePickerFormat,
        batchInfoAccessLevel: this.batchInfoAccessLevel,
        batchInsertEnabled: this.batchInsertEnabled,
        showTasksheets: this.showTasksheets,
        batchRefTrim: this.batchRefTrim,
        //functions
        requestBatches: this.requestBatches,
        hoverOn: this.hoverOn,
        hoverOff: this.hoverOff,
        backToBatches: this.backToBatches,
        //button routes
        routeToViewProof: this.routeToViewProof,
        routeToInsert: this.routeToInsert,
        routeToRejected: this.routeToRejected,
        routeToViewDocs: this.routeToViewDocs,
        //modal functions
        resetModal: this.resetModal,
        modalCreator: this.modalCreator,
        clearResponse: this.clearResponse,
      }
    },
    data() {
      return {
        fields: [
          {key: 'id', label:'tableHeadBatchNumber', tdClass: 'standard-cell-width-sm', thClass: 'standard-th-width-sm brand-color'},
          {key: 'reference', label: 'tableHeadBatchReference', tdClass: 'standard-cell-width-xl cell-large', sortable: true, thClass: 'standard-th-width-xl showhand brand-color'},
          {key: 'documents', label: 'tableHeadDocuments', tdClass: 'standard-cell-width-sm', thClass: 'standard-th-width-sm brand-color'},
          {key: 'type', label: 'tableHeadType', sortable: true, tdClass: 'standard-cell-width-md', thClass: 'standard-th-width-md showhand brand-color'},
          {key: 'status', label: 'tableHeadStatus', sortable: true, tdClass: 'standard-cell-width-md', thClass: 'standard-th-width-md showhand brand-color'},
          {key: 'added_on', label: 'tableHeadAddedOn', sortable: false, tdClass: 'standard-cell-width-md', thClass: 'standard-th-width-md showhand brand-color'},
          {key: 'actions', label: '', sortable: false, tdClass: 'standard-cell-width-xl', thClass: 'standard-th-width-xl brand-color'}
        ],
        paginationVisible: true,
        currentPage: 1,
        perPage: 20,
        batch_id: [],
        sortBy: null,
        sortDesc: true,
        pageOptions: [10, 20, 50, 100, 500],
        filter: null,
        isBusy: false,
        rowEmpty: false,
        totalRows: null,
        filteredRows: '',
        maxDate: '',
        minDate: '',
        subOpened: false,
        subBatches: [],
        arrivedToPage: false,
        datePickerAfterConfig: {
          icons: {
            time: 'os-icon os-icon-calendar-time',
            date: 'os-icon os-icon-basic-2-259-calendar',
            up: 'os-icon os-icon-chevron-up',
            down: 'os-icon os-icon-chevron-down',
            previous: 'os-icon os-icon-chevron-left',
            next: 'os-icon os-icon-chevron-right',
            clear: 'os-icon os-icon-trash',
            close: 'os-icon os-icon-cancel-circle'
          },
          showClear: true
        },
        datePickerBeforeConfig: {
          icons: {
            time: 'os-icon os-icon-calendar-time',
            date: 'os-icon os-icon-basic-2-259-calendar',
            up: 'os-icon os-icon-chevron-up',
            down: 'os-icon os-icon-chevron-down',
            previous: 'os-icon os-icon-chevron-left',
            next: 'os-icon os-icon-chevron-right',
            clear: 'os-icon os-icon-trash',
            close: 'os-icon os-icon-cancel-circle'
          },
          minDate: moment('1979-01-01', this.datePickerFormat),
          showClear: true
        },
        batchEntriesRequest: {
          page: this.$route.query.page ? this.$route.query.page : 1,
          per_page: this.$route.query.per_page ? this.$route.query.per_page : 20,
          batch_ref: this.$route.query.batch_ref,
          batch_id: this.$route.query.batch_id,
          upload_after : this.$route.query.upload_after,
          upload_before : this.$route.query.upload_before,
          batch_type: this.$route.query.batch_type,
          batch_status: this.$route.query.batch_status,
          sub_batch_name: this.$route.query.sub_batch_name,
          invoice_from: this.$route.query.invoice_from,
          invoice_to: this.$route.query.invoice_to,
          invoice_number: this.$route.query.invoice_number,
          customer_number: this.$route.query.customer_number,
          expand_all: this.$route.query.expand_all,
          expanded: this.$route.query.expanded,
          view_subbatch: this.$route.query.view_subbatch
        },
        //Data storage for the modals
        modal: {
          modalData: {},
          batchData: {},
          //editModal specific
          updateBatchRequest: {
            batchId: 0,
            testMode: '',
            deliveryMode: ''
          }
        },
        visibleSearchBox: true,
        showResponse: false,
        dataUrl: '',
        overlayActive: false,
        requestFinished: false,
        infiniteScroll: false,
        lastPage: 1,
        showScrollTopButton: false,
        isBusyTables: false,
        statusSettings: {
          approved: {
            title: 'manageBatchesStatusApproved',
            color: 'btn-green'
          },
          proof: {
            title: 'manageBatchesStatusProof',
            color: 'btn-yellow'
          },
          rejected: {
            title: 'manageBatchesStatusRejected',
            color: 'btn-danger'
          },
          uploaded: {
            title: 'manageBatchesStatusUploaded',
            color: 'btn-gray'
          }
        },
        parentId: null,
        subLoading: false,
        expandAll: false
      }
    },
    computed: {
        ...mapGetters(['allTemplateDetails', 'getBatchEntries', 'getBatchTypes', 'getUserDetails']),
        //...mapGetters('manageBatchesStore', ['getBatchTypes']),
        batchEntries: {
          get() {
            return this.$store.getters.getBatchEntries
          },
          set(entryCleaner) {
            this.$store.commit('setBatchEntries', entryCleaner)
          }
        },
        quarantineStatus: {
          get() {
            return this.$store.getters.getQuarantineStatus
          },
          set(quarantineStatus) {
            this.$store.commit('setQuarantineStatus', quarantineStatus)
          }
        },
        batchTypes: {
          get() {
            return this.$store.getters.getBatchTypes
          },
          set(batchTypes) {
            this.$store.commit('setBatchTypes', batchTypes)
          }
        },
        clientName() {
          let clientName = clientShortName()
          return clientName
        },
        userLevel: {
          get() {
            return this.$store.getters.getUserLevel
          }
        },
        datePickerFormat: {
          get() {
            if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
              let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
              return dateformat
            } else {
              return "DD-MM-YYYY"
            }
          }
        },
        searchOrder: {
          get() {
            return this.$store.getters.allTemplateDetails.searchOrder
          }
        },
        batchInfoAccessLevel: {
          get() {
            return this.$store.getters.allTemplateDetails.batchInfoAccessLevel
          }
        },
        showTasksheets: {
          get() {
            return this.$store.getters.allTemplateDetails.showTasksheets
          }
        },
        batchRefTrim: {
          get() {
            return this.$store.getters.allTemplateDetails.batchRefTrim
          }
        },
        batchInsertEnabled: {
          get() {
            return this.$store.getters.allTemplateDetails.batchInsert
          }
        },
        date_from() {
          return this.batchEntriesRequest.upload_after
        },
        animationName() {
          if(this.subOpened) {
            return 'slide'
          } else {
            return 'sub-slide'
          }
        }
    },
    watch: {
      date_from(date) {
        if(date) {
          let dateFrom = moment(date, this.datePickerFormat)
          this.datePickerBeforeConfig.minDate = dateFrom
        } else {
          this.datePickerBeforeConfig.minDate = moment(new Date('1979-01-01'), this.datePickerFormat)
        }
      },
      perPage() {
        if(this.batchEntriesRequest.per_page !== this.perPage && !this.infiniteScroll) {
          this.batchEntriesRequest.per_page = this.perPage
          this.requestBatches()
        }
      }
    },
    methods: {
      toggleDetails(data) {
        if (!data.detailsShowing) {
          data.item.loading = true

          if (this.batchEntriesRequest.expand_all != 1) {
            if (this.batchEntriesRequest.expanded) {
              if (Array.isArray(this.batchEntriesRequest.expanded) && !this.batchEntriesRequest.expanded.includes(data.item.id)) {
                this.batchEntriesRequest.expanded.push(data.item.id)
              }
            } else {
              this.batchEntriesRequest.expanded = [data.item.id]
            }
          }

          this.$router.push({ query: { ...this.$route.query, expanded: this.batchEntriesRequest.expanded} })

          this.$store.dispatch('getParentBatch', {
            batch_id: data.item.id,
            batch_ref: this.$route.query.batch_ref,
            upload_after : this.$route.query.upload_after,
            upload_before : this.$route.query.upload_before,
            batch_type: this.$route.query.batch_type,
            batch_status: this.$route.query.batch_status,
            sub_batch_name: this.$route.query.sub_batch_name,
            invoice_from: this.$route.query.invoice_from,
            invoice_to: this.$route.query.invoice_to,
            invoice_number: this.$route.query.invoice_number,
            customer_number: this.$route.query.customer_number,
          }).then(response => {
            if (response && response.data && response.data[0]) {
              Object.assign(data.item, response.data[0])
            }
          }).finally(() => {
            data.item.loading = false
          })
        } else {
          if (this.batchEntriesRequest.expand_all != 1) {
            if (this.batchEntriesRequest.expanded) {
              if (Array.isArray(this.batchEntriesRequest.expanded) && this.batchEntriesRequest.expanded.includes(data.item.id)) {
                this.batchEntriesRequest.expanded = this.batchEntriesRequest.expanded.filter(function(value) { return value != data.item.id })
              }
            } else {
              this.batchEntriesRequest.expanded = undefined
            }
          }

          this.$router.push({ query: { ...this.$route.query, expanded: this.batchEntriesRequest.expanded}})
        }

        data.toggleDetails()
      },
      showDetails(data) {
        this.subLoading = true
        this.subOpened = true
        this.batchEntriesRequest.view_subbatch = data.item.id
        this.$router.push({ query: { ...this.$route.query, view_subbatch: this.batchEntriesRequest.view_subbatch} })
        this.$store.dispatch('getParentBatch', {
          batch_id: data.item.id,
          batch_ref: this.$route.query.batch_ref,
          upload_after : this.$route.query.upload_after,
          upload_before : this.$route.query.upload_before,
          batch_type: this.$route.query.batch_type,
          batch_status: this.$route.query.batch_status,
          sub_batch_name: this.$route.query.sub_batch_name,
          invoice_from: this.$route.query.invoice_from,
          invoice_to: this.$route.query.invoice_to,
          invoice_number: this.$route.query.invoice_number,
          customer_number: this.$route.query.customer_number,
        }).then(response => {
          if (response && response.data && response.data[0]) {
            Object.assign(data.item, response.data[0])
          }
        }).finally(() => {
          this.subLoading = false
          if (data.item.sub_batch && data.item.sub_batch.length > 0) {
            this.subBatches = data.item.sub_batch
            this.parentId = data.item.id
          }
        })
      },
      hideResponse() {
        this.showResponse = false
      },
      onFiltered(filteredItems) {
        this.filteredRows = filteredItems.length
        this.currentPage = 1
      },
      manualPagination(newPage) {
        let page = parseInt(newPage)
        if(this.batchEntriesRequest.page !== page && !this.infiniteScroll) {
          this.batchEntriesRequest.page = page
          this.requestBatches()
        }

        if(this.$refs.paginationTop) {
          if(this.batchEntriesRequest.page != this.$refs.paginationTop.currentPage) {
            this.$refs.paginationTop.currentPage = this.batchEntriesRequest.page
          }
        }

        if(this.$refs.paginationBottom) {
          if(this.batchEntriesRequest.page != this.$refs.paginationBottom.currentPage) {
            this.$refs.paginationBottom.currentPage = this.batchEntriesRequest.page
          }
        }
      },
      backToBatches() {
        this.batchEntriesRequest.view_subbatch = undefined
        this.$router.push({ query: { ...this.$route.query, view_subbatch: this.batchEntriesRequest.view_subbatch} })
        this.subBatches = []
        this.parentId = null
        this.subOpened = false
      },
      paginationCorrector(el) {
        //if(!this.subOpened) {
        if(el.id === 'table-sub') {
          if(this.$refs.paginationTop) {
            if(this.batchEntriesRequest.page != this.$refs.paginationTop.currentPage) {
              this.$refs.paginationTop.currentPage = this.batchEntriesRequest.page
            }
          }
          if(this.$refs.paginationBottom) {
            if(this.batchEntriesRequest.page != this.$refs.paginationBottom.currentPage) {
              this.$refs.paginationBottom.currentPage = this.batchEntriesRequest.page
            }
          }
        }
      },
      paginationVisibilityStart(el) {
        if(el.id === 'table-sub') {
          this.paginationVisible = false
        }
      },
      paginationVisibilityEnd(el) {
        if(el.id === 'table-main') {
          this.paginationVisible = true
        }
      },
      requestBatches($appendResults = false, $state = null) {
        //NS-10737, when infinite scrolling is enabled, after any action that performs the search again,
        // we load all data from the first page to the current page, VY
        let appendAfterAction = false
        this.isBusyTables = true

        if(typeof $appendResults == 'undefined' || typeof $appendResults != 'boolean') {
          $appendResults = false;
        }

        if(!$appendResults) {
          if (this.infiniteScroll) {
              appendAfterAction = true
          }
          this.isBusy = true
        }

        this.subBatches = []
        this.subOpened = false

        Object.keys(this.batchEntriesRequest).forEach((key) => ((this.batchEntriesRequest[key] == '') || (this.batchEntriesRequest[key] == null)) && (this.batchEntriesRequest[key] = undefined))

        if ((this.clientName === 'unis' || this.clientName === 'unistest') && (this.userLevel == 1.50)) {
          this.$router.push({ query: { ...this.$route.query, ...this.batchEntriesRequest, page: this.batchEntriesRequest.page, per_page: this.batchEntriesRequest.per_page, batch_status: 'proof'} })
        }else {
          this.$router.push({ query: { ...this.$route.query, ...this.batchEntriesRequest, page: this.batchEntriesRequest.page, per_page: this.batchEntriesRequest.per_page} })
        }

        if(this.batch_id){
          if(!Array.isArray(this.batch_id)) {
            let ids = this.batch_id.split(',')
            this.batch_id = []
            Object.keys(ids).forEach(
              (key) => (
                ( this.batch_id.push(parseInt(ids[key])))
              )
            )

            this.$router.push({ query: { ...this.$route.query, batch_id: this.batch_id} })
            this.batchEntriesRequest.batch_id = [ ...this.batch_id]
          }
        }else{
          this.batchEntriesRequest.batch_id = []
          this.$router.push({ query: { ...this.$route.query, batch_id: this.batchEntriesRequest.batch_id} })
        }

        this.$store.dispatch('getBatchEntries', {
            page: this.batchEntriesRequest.page,
            per_page: this.batchEntriesRequest.per_page,
            batch_ref: this.$route.query.batch_ref,
            batch_id: this.batchEntriesRequest.batch_id,
            upload_after : this.$route.query.upload_after,
            upload_before : this.$route.query.upload_before,
            batch_type: this.$route.query.batch_type,
            batch_status: this.batchEntriesRequest.batch_status,
            sub_batch_name: this.$route.query.sub_batch_name,
            invoice_from: this.$route.query.invoice_from,
            invoice_to: this.$route.query.invoice_to,
            invoice_number: this.$route.query.invoice_number,
            customer_number: this.$route.query.customer_number,
            append_results: $appendResults,
            append_after_action: appendAfterAction,
            expanded: this.$route.query.expanded,
            expand_all: this.$route.query.expand_all
        })
        .then(() => {
          this.isBusyTables = false
          this.isBusy = false
          this.loadMoreData = true
          // NS-10026 variable to declare if the first request has finished, PW
          this.requestFinished = true

          if(this.arrivedToPage === false) {
            this.$refs.searchForm.show = false
          }else{
            this.$refs.searchForm.show = true
          }

          if($appendResults) {
            this.infiniteScroll = true
          }

          //if we try to access a page that has no entries because it's after the last page
          //we set the pagination back to default and fetch the batches with the correct pagination
          if(this.batchEntries.current_page > this.batchEntries.last_page) {
            this.batchEntriesRequest.page = 1
            this.batchEntriesRequest.per_page = 20
            this.requestBatches()
          }

          if($state != null) {
            $state.loaded()
          }

          this.lastPage = this.batchEntries.last_page
          this.totalRows = this.batchEntries.total

          if((this.batchEntries.data === undefined)||(this.batchEntries.data.length == 0)) {
            this.rowEmpty = true
            this.loadMoreData = false
            if($state != null) {
              $state.complete()
            }
          } else {
            this.visibleSearchBox = false
          }

          //setting the table variables
          this.currentPage = parseInt(this.batchEntriesRequest.page)
          this.perPage = parseInt(this.batchEntriesRequest.per_page)

          //setting the pagination manually
          this.manualPagination(parseInt(this.batchEntriesRequest.page))
          if(this.batchEntries.current_page >= this.batchEntries.last_page) {
            this.loadMoreData = false
            if($state != null) {
              $state.complete()
            }
          }

          if(this.infiniteScroll && this.batchEntries.data && this.batchEntries.data[Object.entries(this.batchEntries.data).length] > 15) {
            document.getElementById("batches-table__row_" + this.batchEntries.data[Object.entries(this.batchEntries.data).length - 15].id).scrollIntoView();
          }

          if(this.$route.query.view_subbatch) {
            let index = null
            index = this.batchEntries.data.findIndex(batch => batch.id == this.$route.query.view_subbatch);

            if(index > -1) {
              // NS-10611 If the parent batch index was found we check its subbatches, if found we trigger subbatch view
              let subbatches = this.batchEntries.data[index].sub_batch
              if (subbatches) {
                this.subBatches = subbatches
                this.parentId = subbatches[0].parent.id
                this.subOpened = true
                this.batchEntriesRequest.view_subbatch = this.parentId
                this.$router.push({ query: { ...this.$route.query, view_subbatch: this.batchEntriesRequest.view_subbatch} })
              }
            } else {
              this.batchEntriesRequest.view_subbatch = undefined
              this.$router.push({ query: { ...this.$route.query, view_subbatch: this.batchEntriesRequest.view_subbatch} })
            }
          }

          this.arrivedToPage = false
        })
      },
      // NS-11360 Changed batch download to only use batch id, PW
      downloadBatchData(batchId) {
        this.$store.dispatch('tokenStore/createDownloadToken', null).then(response => {
          let accessToken = response
          
          // NS-11360 removed type name from the url, PW 
          this.dataUrl = backendUrl() + '/downloadBatchData/' + batchId + '/' + accessToken
          this.overlayActive = true
          this.$root.$emit('bv::show::modal', 'downloadModal')
        })
      },
      //universal modal creator
      modalCreator(modalData, batchData, button) {
        this.modal.modalData = modalData
        this.modal.batchData = { ...batchData }

        if(modalData.id == 'editModal') {
          this.modal['updateBatchRequest'].batchId = batchData.id
          if((typeof batchData.test_mode === 'undefined') || (batchData.test_mode == null)) {
            this.modal['updateBatchRequest'].testMode = 0
            this.modal['updateBatchRequest'].deliveryMode = 'simulate'
          } else if(batchData.test_mode == 'Divert deliveries') {
            this.modal['updateBatchRequest'].testMode = 1
            this.modal['updateBatchRequest'].deliveryMode = 'divert'
          } else {
            this.modal['updateBatchRequest'].testMode = 1
            this.modal['updateBatchRequest'].deliveryMode = 'simulate'
          }
        }

        this.$root.$emit('bv::show::modal', this.modal.modalData.id, button)
      },
      //Modal resetter
      resetModal(modal) {
        Object.keys(this.modal['modalData']).forEach((key) => (key === 'id') ? this.modal['modalData'][key] : (this.modal['modalData'][key] = '' ))
        Object.keys(this.modal['batchData']).forEach((key) => (this.modal['batchData'][key] = '' ))
        Object.keys(this.modal['updateBatchRequest']).forEach((key) => (this.modal['updateBatchRequest'][key] = '' ))
      },
      clearResponse() {
        this.$store.dispatch('alertClearResponse')
      },
      //display or hide the edit, info and cancel icons on hover
      hoverOn(item) {
        let itemId = item.id
        let editElement = document.getElementById('edit-' + itemId)
        let infoElement = document.getElementById('info-' + itemId)
        let cancelElement = document.getElementById('cancel-' + itemId)
        if(editElement) {
          editElement.setAttribute('visibility', 'visible')
        }
        if(infoElement) {
          infoElement.setAttribute('visibility', 'visible')
        }
        if(cancelElement) {
          cancelElement.setAttribute('visibility', 'visible')
        }
      },
      hoverOff(item) {
        let itemId = item.id
        let editElement = document.getElementById('edit-' + itemId)
        let infoElement = document.getElementById('info-' + itemId)
        let cancelElement = document.getElementById('cancel-' + itemId)
        if(editElement) {
          editElement.setAttribute('visibility', 'hidden')
        }
        if(infoElement) {
          infoElement.setAttribute('visibility', 'hidden')
        }
        if(cancelElement) {
          cancelElement.setAttribute('visibility', 'hidden')
        }
      },
      /*
      *   navigation buttons for batches
      */
      routeToBatchStatus(batchId) {
        //this.$router.push({ name: 'batch_status', params: { batch: batchId} })
        this.$router.push({ name: 'batch_status', query: { batch_id: batchId} })
      },
      routeToViewProof(batchId, taskSheet, client) {
        if(client === ('dipt' || 'dipttest')) {
          if(taskSheet) {
            //this.$router.push({ name: 'view_proof', query: { batch: batchId, taskSheet: true, sortField: 'customer_ref', sortDirection: 'ASC'} })
            this.$router.push({ path: '/documents/proof', query: { page: 1, per_page: 20, batch: batchId, taskSheet: true, sort_field: 'customer_ref', sort_direction: 'ASC'} })
          } else {
            //this.$router.push({ name: 'view_proof', query: { batch: batchId, sortField: 'customer_ref', sortDirection: 'ASC'} })
            this.$router.push({ path: '/documents/proof', query: { page: 1, per_page: 20, batch: batchId, taskSheet: true, sort_field: 'customer_ref', sort_direction: 'ASC'} })
          }
        } else {
          if(taskSheet) {
            //this.$router.push({ name: 'view_proof', query: { batch: batchId, taskSheet: true} })
            this.$router.push({ path: '/documents/proof', query: { page: 1, per_page: 20, batch: batchId, taskSheet: true} })
          } else {
            //this.$router.push({ name: 'view_proof', query: { batch: batchId} })
            this.$router.push({ path: '/documents/proof', query: { page: 1, per_page: 20, batch: batchId} })
          }
        }
      },
      routeToInsert(batchId) {
        this.$router.push({ name: 'batch_insert', query: { page: 1, per_page: 20, batch: batchId} })
      },
      routeToRejected(batchId) {
        //this.$router.push({ name: 'view_proof', query: { batch: batchId} })
        this.$router.push({ path: '/documents/proof', query: { page: 1, per_page: 20, batch: batchId} })
      },
      routeToViewDocs(batchId, client) {
        if (client === ('dipt' || 'dipttest')) {
          //this.$router.push({ name: 'documents_search', query: { batch: batchId, sortField: 'customer_ref', sortDirection: 'ASC'} })
          this.$router.push({ path: '/documents/search', query: { page: 1, per_page: 20, batch: batchId, sort_field: 'customer_ref', sort_direction: 'ASC'} })
        } else {
          //this.$router.push({ name: 'documents_search', query: { batch: batchId} })
          this.$router.push({ path: '/documents/search', query: { page: 1, per_page: 20, batch: batchId} })
        }
      },
      listAllBatches() {
        if (this.totalRows / this.perPage > 1) {
          this.infiniteScroll = true
        }
        this.isBusy = false
        this.batchEntriesRequest.page = 1
        this.requestBatches()
      },
      expandAllBatches () {
        if (this.batchEntriesRequest.expand_all != 1) {
          this.batchEntriesRequest.expand_all = 1
          this.batchEntriesRequest.expanded = null
        } else {
          this.batchEntriesRequest.expand_all = 0
        }

        this.requestBatches()
      },
      resetInfiniteScroll() {
        this.batchEntriesRequest.page = 1
        this.infiniteScroll = false
        this.showScrollTopButton = false
      },
      infiniteHandler($state) {
        if (!this.isBusy && this.batchEntriesRequest.page < this.lastPage && this.infiniteScroll && !this.isBusyTables) {
          this.batchEntriesRequest.page += 1
          this.requestBatches(true, $state)
        }

        if (this.infiniteScroll && this.batchEntriesRequest.page > 1) {
          this.showScrollTopButton = true
        } else {
          this.showScrollTopButton = false
        }
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      },
      fixInfinitePage() {
        if (this.infiniteScroll && this.batchEntriesRequest.page > 1) {
          this.batchEntriesRequest.page = 1
          this.infiniteScroll = false
          this.showScrollTopButton = false
          this.requestBatches()
        }
      },
      exportControlFile(batchId, filename) {
        this.$store.dispatch('checkBatchData', {
          batchId: batchId
        }).then(response => {
          if(response.status && response.status === 'success') {
            this.$store.dispatch('tokenStore/createDownloadToken', null).then(response => {
              let accessToken = response
              
              this.dataUrl = backendUrl() + '/downloadControlFile/' + batchId + '/' + accessToken
              this.overlayActive = true
              this.$root.$emit('bv::show::modal', 'downloadModal')
            })
          }
        }, this)
      }
    },
    created() {
      if(this.$route.params.response) {
        if(this.$route.params.response == 'approveSuccess') {
          this.showResponse = true
        }
      }

      this.batchTypes = this.$store.dispatch('getBatchTypes')
      this.quarantineStatus = this.$store.dispatch('getQuarantineStatus')

      this.arrivedToPage = true
      // initializing the datepicker's format
      this.datePickerAfterConfig.format = this.datePickerFormat
      this.datePickerBeforeConfig.format = this.datePickerFormat

      let todaysDate = moment(new Date(), this.datePickerFormat)
      this.datePickerAfterConfig.maxDate = todaysDate
      this.datePickerBeforeConfig.maxDate = todaysDate

      // initializing the table sorting
      let searchOder = this.$store.getters.allTemplateDetails.searchOrder
      if (searchOder == 'id') {
        this.sortBy = 'id'
      } else {
        this.sortBy = 'added_on'
      }

      if(Object.keys(this.$route.query).length && !this.infiniteScroll) {
        this.batchEntriesRequest = Object.assign({}, this.$route.query)

        if(this.$route.query.page) {
          this.batchEntriesRequest.page = parseInt(this.$route.query.page)
        } else {
          this.batchEntriesRequest.page = 1
        }

        if(this.$route.query.per_page) {
          this.batchEntriesRequest.per_page = parseInt(this.$route.query.per_page)
        } else {
          this.batchEntriesRequest.per_page = 20
        }

        if (this.$route.query.batch_status) {
          if (!Array.isArray(this.$route.query.batch_status)) {
            this.batchEntriesRequest.batch_status = Array.of(this.$route.query.batch_status)
          }
        } else {
          if ((this.clientName === 'unis' || this.clientName === 'unistest') && (this.userLevel == 1.50)) {
            this.batchEntriesRequest.batch_status = ['proof']
          } else {
            this.batchEntriesRequest.batch_status = ['all']
          }
        }

        if(this.$route.query.batch_id) {
          if(Array.isArray(this.$route.query.batch_id)) {
            Object.keys(this.$route.query.batch_id).forEach(
              (key) => (
                ( this.batch_id.push(parseInt(this.$route.query.batch_id[key])))
              )
            )
          } else {
            this.batch_id.push(parseInt(this.$route.query.batch_id))
          }
        }
        if(this.batch_id) {
          this.batchEntriesRequest.batch_id = this.batch_id
        }


        if (this.$route.query.expanded) {
          if (!Array.isArray(this.$route.query.expanded)) {
            this.batchEntriesRequest.expanded = Array.of(parseInt(this.$route.query.expanded))
          } else {
            this.batchEntriesRequest.expanded = this.batchEntriesRequest.expanded.map(value => parseInt(value))
          }
        }

        this.requestBatches()
      } else {
        if((this.batchEntriesRequest.page == undefined) || (this.batchEntriesRequest.page == null) || (this.batchEntriesRequest.page == '')){
          this.batchEntriesRequest.page = 1
        }
        if((this.batchEntriesRequest.per_page == undefined) || (this.batchEntriesRequest.per_page == null) || (this.batchEntriesRequest.per_page == '')){
          this.batchEntriesRequest.per_page = 20
        }
        if ((this.batchEntriesRequest.batch_status == undefined) || (this.batchEntriesRequest.batch_status == null) || (this.batchEntriesRequest.batch_status == '') || (this.batchEntriesRequest.batch_status == [])) {
          if ((this.clientName === 'unis' || this.clientName === 'unistest') && (this.userLevel == 1.50)) {
            this.batchEntriesRequest.batch_status = ['proof']
          } else {
            this.batchEntriesRequest.batch_status = ['all']
          }
        }
        this.requestBatches()
      }

    },
    beforeDestroy() {
      this.batchEntries = {}
    },
    filters: {
      trimBatchReference: function(reference, batchRefTrim) {
        if (reference && reference !== '') {
          return reference.slice(0, batchRefTrim)
        }
      },
      humanReadable: function(date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a')
      },
      clientDateFormat: function(date, datePickerFormat) {
          return moment(date).format(datePickerFormat + ' hh:mm:ss')
        //return moment(date).format(datePickerFormat)
      },
      clientDateFormat2: function(date, datePickerFormat) {
        // NS-10381 Change format for GSKP ( will require better solution later on )
        return moment(date).format(datePickerFormat + ' HH:mm:ss')
      }
    },
    components: {
      ToolBar,
      SubBatch,
      ModalBatchDelete,
      ModalDeleteAllTestBatches,
      ModalInfoBatch,
      ModalEditBatch,
      ModalCancelBatch,
      ModalDontRemind,
      ModalDownloadData,
      Loading,
      datePicker,
      VclTable
    }
}
</script>

<style scoped>
/*-----SEARCH BAR-----*/
.text-netsend-blue{
  color: #047bf8;
}
.batch-search-border{
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 10px;
}
#batchToggle{
  font-size: 1.2rem;
  font-weight: bold;
  display:inline-block;
  -moz-transition: all .5s linear;
  -webkit-transition: all .5s linear;
  transition: all .5s linear;
}
#batchToggle.collapsed{
  -moz-transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
  transform:rotate(180deg);
}

.showhand{
  cursor: pointer;
}

.disablehand{
  pointer-events: none
}

.text-shadow{
text-shadow: 0 0 1px rgba(0,0,0,0.7);
}
/*-----TABLE TRANSITION-----*/
.slide-enter-active {
 -moz-transition-duration: 0.4s;
 -webkit-transition-duration: 0.4s;
 -o-transition-duration: 0.4s;
 transition-duration: 0.4s;
 -moz-transition-timing-function: ease-in;
 -webkit-transition-timing-function: ease-in;
 -o-transition-timing-function: ease-in;
 transition-timing-function: ease-in;
}
.slide-leave-active {
 -moz-transition-duration: 0.4s;
 -webkit-transition-duration: 0.4s;
 -o-transition-duration: 0.4s;
 transition-duration: 0.4s;
 -moz-transition-timing-function: ease-out;
 -webkit-transition-timing-function: ease-out;
 -o-transition-timing-function: ease-out;
 transition-timing-function: ease-out;
}
.slide-leave {
 transform: translateX(0);
}
.slide-enter-to {
  transform: translateX(0);
}
.slide-enter {
  transform: translateX(100%);
}
.slide-leave-to {
  transform: translateX(-100%);
}

.sub-slide-enter-active {
 -moz-transition-duration: 0.4s;
 -webkit-transition-duration: 0.4s;
 -o-transition-duration: 0.4s;
 transition-duration: 0.4s;
 -moz-transition-timing-function: ease-in;
 -webkit-transition-timing-function: ease-in;
 -o-transition-timing-function: ease-in;
 transition-timing-function: ease-in;
}
.sub-slide-leave-active {
 -moz-transition-duration: 0.4s;
 -webkit-transition-duration: 0.4s;
 -o-transition-duration: 0.4s;
 transition-duration: 0.4s;
 -moz-transition-timing-function: ease-out;
 -webkit-transition-timing-function: ease-out;
 -o-transition-timing-function: ease-out;
 transition-timing-function: ease-out;
}
.sub-slide-enter-to {
 transform: translateX(0);
}
.sub-slide-leave {
 transform: translateX(0);
}
.sub-slide-enter{
  transform: translateX(-100%);
}
.sub-slide-leave-to {
  transform: translateX(110%);
}
/*
.slide-enter-to, .slide-leave {
 width: 100%;
 overflow: hidden;
}
.slide-enter, .slide-leave-to {
 overflow: hidden;
 width: 0%;
}*/


.results-height-fix {
  min-height: 700px;
}

/*-----Custom button and dropdown colours-----*/
.btn-yellow{
  background-color: #e67e22;
  border-color: #e67e22;
}
.btn-yellow:hover{
  background-color: #d35400;
  border-color: #d35400;
}
.btn-green{
  background-color: #1abc9c;
  border-color: #1abc9c;
}
.btn-green:hover{
  background-color: #16a085;
  border-color: #16a085;
}
.btn-gray {
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-gray:hover {
  background-color: #545b62;
}
.btn-danger {
  color: #fff;
  background-color: #e65252;
}
.btn-danger:hover {
  background-color: #e02525;
}

#action-dropdown >>> ul {
  padding: 0px !important;
  margin-top: 0px !important;
  background-color: white;
  /*
  border: 2px solid grey;
  border-radius: 5px;
  */
  border: 2px solid white;
  box-shadow: 0 0 1px rgba(15, 24, 33, 0.5),
  0 25px 65px rgba(15, 24, 33, 0.29);
}
#action-dropdown >>> ul span .optn{
  border-top: 2px solid white;
  border-radius: 3px;
}
.optn-blue{
  background-color: #3498db;
  border-color: #3498db;
}
.optn-blue:hover{
  background-color: #2980b9;
  border-color: #2980b9;
}
#action-dropdown >>> .optn-blue .dropdown-item:hover{
  background-color: #2980b9;
  border-color: #2980b9;
  border-radius: 3px;
}
.optn-purple{
  background-color: #9b59b6;
  border-color: #9b59b6;
}
.optn-purple:hover{
  background-color: #8e44ad;
  border-color: #8e44ad;
}
#action-dropdown >>> .optn-purple .dropdown-item:hover{
  background-color: #8e44ad;
  border-color: #8e44ad;
  border-radius: 3px;
}
.optn-grey{
  background-color: #34495e;
  border-color: #34495e;
}
.optn-grey:hover{
  background-color: #2c3e50;
  border-color: #2c3e50;
}
#action-dropdown >>> .optn-grey .dropdown-item:hover{
  background-color: #2c3e50;
  border-color: #2c3e50;
  border-radius: 3px;
}
.optn-red{
  background-color: #dc3545;
  border-color: #dc3545;
}
.optn-red:hover {
  background-color: #c82333;
  border-color: #c82333;
}
#action-dropdown >>> .optn-red .dropdown-item:hover{
  background-color: #c82333;
  border-color: #c82333;
  border-radius: 3px;
}

.hr{
  display: block;
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

/*-----Batch Entries Table Styles-----*/
.table-responsive{
  max-width: 90vw !important;
  margin: 0 auto;
  overflow-x: auto;
}
.table-responsive >>> table td.standard-cell-width-sm{
  width: 100%;
  padding: 12px !important;
  min-width: 90px !important;
  max-width: 90px !important;
}
.table-responsive >>> table th.standard-th-width-sm{
  width: 100%;
  padding: 12px !important;
  min-width: 90px !important;
  max-width: 90px !important;
}
.table-responsive >>> table td.standard-cell-width-md{
  width: 100%;
  padding: 12px !important;
  min-width: 160px !important;
  max-width: 160px !important;
}
.table-responsive >>> table th.standard-th-width-md{
  width: 100%;
  padding: 12px !important;
  min-width: 160px !important;
  max-width: 160px !important;
}
.table-responsive >>> table td.standard-cell-width-xl{
  padding: 12px !important;
  width: 100%;
  min-width: 380px !important;
  max-width: 380px !important;
  word-break: break-all; /*NS-11200 It corrects the overflow of the text's Sub Batch column, RS*/
}
.table-responsive >>> table th.standard-th-width-xl{
  width: 100%;
  padding: 12px !important;
  min-width: 380px !important;
  max-width: 380px !important;
}
.table-responsive >>> .sub-batch table{
  box-sizing: content-box !important;
  width: 100% !important;
}
.table-responsive >>> .sub-batch  table td:last-of-type{
  border-right: 0 !important;
}
.table-responsive >>> .sub-batch table td:first-of-type{
  border-left: 0 !important;
}
.table-responsive >>> .sub-batch table tr:last-of-type > td{
  border-bottom: 0 !important;
}
.table-responsive >>> .sub-batch table tr:first-of-type > td{
  border-top: 0 !important;
}
.table-responsive >>> table td, .table-responsive >>> table th{
  box-sizing: content-box !important;
}
.table-responsive >>> .sub-batch table td{
  background-color: rgba(4, 123, 248, 0.1);
}
.table-responsive >>> .cell-no-border{
  border-top: none;
  border-left: none;
  border-right: none;
}
.table-responsive >>> .cell-no-border-last{
  border-top: none;
  border-left: none;
}
.table-responsive >>> .cell-no-border-head{
  border-left: none;
  border-right: none;
}
.table-responsive >>> .cell-no-border-head-last{
  border-left: none;
}

/*-----Placeholder text centering-----*/
::-webkit-input-placeholder {
  text-align: center;
}
:-moz-placeholder { /* Firefox 18- */
  text-align: center;
}
::-moz-placeholder {  /* Firefox 19+ */
  text-align: center;
}
:-ms-input-placeholder {
  text-align: center;
}

/*-----Batch Info Modal Styles*/
.modal-open #infoModal___BV_modal_outer_ >>> .modal-content{
  min-width: 700px !important;
  max-width: auto !important;
  width: auto !important;
}
.modal-open #infoModal___BV_modal_outer_ >>> .modal-content .modal-body{
  max-height: 450px;
  overflow-y: scroll;
}
.log-textbox{
  resize: none;
  border-radius: 5px;
  border: 1px solid lightgrey;
}

.info-table tr td:nth-of-type(1), .delete-table tr td:nth-of-type(1){
  background-color: #34495e;
  min-width: 180px;
}
.table-responsive  >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}
.scroll-top-div {
  position: fixed;
  right: 50px;
  bottom: 50px;
  width: 50px;
  height: 50px;
  z-index: 100;
}
.scroll-top-div > button {
  height: 100%;
  width: 100%;
  font-size: 24px;
}
/*NS-11200 It corrects the overflow of the text's Bulk Reference column, RS*/
.break-all {
  word-break: break-all;
}
</style>
